export const USER_TYPES = {
  INVITE_BY_SUPER_ADMIN: 'INVITE_BY_SUPER_ADMIN',
  INVITE_BY_ADMIN: 'INVITE_BY_ADMIN',
  ACTIVE: 'ACTIVE',
  ARCHIVE: 'ARCHIVE',
  DELETED: 'DELETED'
}

export const USER_ROLES = {
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_BOOKKEEPER: 'ROLE_BOOKKEEPER',
  ROLE_REGULAR: 'ROLE_REGULAR',
  FAKE_ROLE_BUDGET_OWNER: 'ROLE_BUDGET_OWNER'
}
